module.exports = __webpack_public_path__ + "static/img/coupon-model-btn.6da8166.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon-model-btn.png
// module id = 5qtH
// module chunks = 0